"use strict";

angular.module("core")
.component("supportAssistant", {
    templateUrl: require("./support-assistant.component.html"),
    controller: SupportAssistantController,
    controllerAs: "supportAssistantCtrl"
});

function SupportAssistantController(
    $window, $scope, $interval, $timeout, ModalService, common,
    SUPPORT_ASSISTANT_MINIMIZED_DEFAULT_VALUE
) {
    var AUTO_HIDE_DELAY = 3000;
    var INIT_DELAY = 1000;

    var _this = this;
    var unregister = $scope.$on("onAPIError", function(event, rejection) {
        _this.minimized = false;
    });

    this.$onDestroy = function() {
        unregister();
    };

    function minimize() {
        _this.minimized = true;
    }

    _this.minimized = SUPPORT_ASSISTANT_MINIMIZED_DEFAULT_VALUE;

    $interval(minimize, AUTO_HIDE_DELAY, 1);

    this.openModal = function() {
        ModalService.showModal({
            templateUrl: require("./support-assistant.modal.html"),
            controller: "SupportAssistantModalController",
            controllerAs: "supportAssistantModalCtrl"
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
        });
    };

    function refreshWidgetPosition() {
        var footerElement = angular.element("#page-footer");
        if (footerElement.size() && $(window).scrollTop() + $(window).height() > footerElement.last().offset().top) {
            $scope.widgetPosition = {
                top: (footerElement.last().offset().top - 100) + "px",
                bottom: "auto",
                position: "absolute"
            };
        }
        else {
            $scope.widgetPosition = {};
        }
    }

    angular.element($window).on("scroll", function() {
        refreshWidgetPosition();
        $scope.$apply();
    });

    angular.element($window).on("resize", function() {
        refreshWidgetPosition();
        $scope.$apply();
    });

    $scope.$on("$stateChangeSuccess", function() {
        $timeout(function() {
            refreshWidgetPosition();
            $scope.$apply();
        }, INIT_DELAY);
    });

    $timeout(function() {
        refreshWidgetPosition();
        $scope.$apply();
    }, INIT_DELAY);
}



//////////////////
// WEBPACK FOOTER
// ./core/support-assistant/support-assistant.component.js
// module id = 578
// module chunks = 0